import React from 'react';

import { StyledTypography } from './styles';

const Typography = props => <StyledTypography {...props} />;

export default Typography;
